import React, { useEffect, useState } from 'react';
import { Button } from '@arcflight/tf-component-library';
import { ButtonSize } from '../../PaginatedDefectsTable/DefectTableHeader';
import styles from '../workpackDrawer.module.less';
import TFPagination from '../../TFPagination/TFPagination';
import { Workpack } from '../../../models/workpacks';

interface ControlsProps {
  saveWorkpack: () => void;
  drawerMode: string;
  status: string;
  pendingWps: Workpack[];
  activeWPId: string;
  handlePendingIndexChange: (index: number) => void;
  removeUnsavedItems: () => void;
  acceptanceSig: string;
  completePendingWorkpack: () => void;
}

const Controls = ({
  saveWorkpack,
  drawerMode,
  status,
  pendingWps,
  activeWPId,
  handlePendingIndexChange,
  removeUnsavedItems,
  acceptanceSig,
  completePendingWorkpack,
}: ControlsProps): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(0);

  const SaveButton = (): JSX.Element => {
    return (
      <div className={styles.buttonWrapper}>
        <Button size={ButtonSize.MEDIUM} onClick={saveWorkpack}>
          Save
        </Button>
        <div className={styles.cancelButtonWrapper}>
          <Button
            size={ButtonSize.MEDIUM}
            primary={false}
            onClick={(): void => {
              removeUnsavedItems();
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    );
  };

  const handleIndexChange = (index: number): void => {
    handlePendingIndexChange(index);
  };
  const completeDisabled = acceptanceSig.length === 0;

  useEffect(() => {
    if (activeWPId) {
      const index = pendingWps.findIndex((wp) => wp.id === activeWPId);
      if (index) setActiveIndex(index);
    }
  }, [activeWPId, pendingWps]);

  return (
    <div className={styles.crsAcceptance}>
      {status === 'pending' && (
        <>
          <button
            type="button"
            className={completeDisabled ? `${styles.blueButton} ${styles.disabledButton}` : styles.blueButton}
            disabled={completeDisabled}
            onClick={completePendingWorkpack}
          >
            Complete
          </button>
          {pendingWps?.length > 1 ? (
            <div className={styles.paginationWrapper}>
              <TFPagination passedArray={pendingWps} activeIndex={activeIndex} handleIndexChange={handleIndexChange} />
            </div>
          ) : null}
        </>
      )}
      {(drawerMode === 'edit' || drawerMode === 'new') && status !== 'pending' && <SaveButton />}
    </div>
  );
};

export default Controls;
